<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>

      <el-input v-model="listQuery.device_name" placeholder="设备名称" class="filter-item" style="width: 200px;" clearable />

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <div class="filter-container">
      <el-button-group>
        <el-button type="primary" size="small" @click="handleCellBatchProcessing('DOOR_OPEN')" :disabled="ids.length <= 0">一键开箱</el-button>
        <el-button type="warning" size="small" @click="handleCellBatchProcessing('LIGHT_OPEN')" :disabled="ids.length <= 0">一键开灯</el-button>
        <el-button type="warning" size="small" @click="handleCellBatchProcessing('LIGHT_CLOSE')" :disabled="ids.length <= 0">一键关灯</el-button>
        <el-button type="success" size="small" @click="handleCellBatchProcessing('WARM_START')" :disabled="ids.length <= 0">一键加热</el-button>
        <el-button type="success" size="small" @click="handleCellBatchProcessing('WARM_STOP')" :disabled="ids.length <= 0">一键停止加热</el-button>
        <el-button type="info" size="small" @click="handleCellBatchProcessing('DISINFECT_START')" :disabled="ids.length <= 0">一键消毒</el-button>
        <el-button type="info" size="small" @click="handleCellBatchProcessing('DISINFECT_STOP')" :disabled="ids.length <= 0">一键停止消毒</el-button>
      </el-button-group>
    </div>

    <el-table v-loading="listLoading" :data="list" @selection-change="handleSelectionChange" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column type="selection" align="center" width="45"></el-table-column>

      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="设备ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.device_id }}
        </template>
      </el-table-column>

      <el-table-column label="设备名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.device_name }}
        </template>
      </el-table-column>

      <el-table-column label="定时消毒" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.disinfect_time ? `${scope.row.disinfect_time[0]}-${scope.row.disinfect_time[1]}` : "" }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>

          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>

          <el-button type="success" size="mini" @click="handleSideboardDeviceCells(scope.row)">格子管理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="设备ID" prop="device_id">
          <el-input v-model="form.device_id" :disabled="!!form.id"></el-input>
        </el-form-item>

        <el-form-item label="定时消毒" prop="disinfect_time">
          <el-time-picker is-range size="small" v-model="form.disinfect_time" format="HH:mm" value-format="HH:mm"  range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          device_name: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          school_id: "",
          device_id: "",
          disinfect_time: null,
        },
        rules: {
          device_id: [{ required: true, message: "设备ID不能为空", trigger: "blur" }],
        },
        // 格子批量处理
        ids: [],
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/sideboardDevice/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          school_id: "",
          device_id: "",
          disinfect_time: null,
        }
        this.btnLoading = false;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        if (!this.school_id) {
          this.$message({
            type: "warning",
            message: "请选择学校"
          });
          return;
        } else {
          this.form.school_id = this.school_id;
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/sideboardDevice/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
      handleDelete(row) {
        this.$confirm("确认继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/sideboardDevice/delete",
            method: "post",
            data: {
              id: row.id
            }
          }).then(()=>{
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          })
        }).catch(() => {});
      },
      // 格子管理
      handleSideboardDeviceCells(row) {
        this.$router.push(`/sideboard/sideboardDeviceCells?id=${row.id}`);
      },
      // 格子批量处理
      handleSelectionChange(val) {
        let ids = [];
        val.forEach(element => {
          ids.push(element.id);
        });
        this.ids = ids;
      },
      handleCellBatchProcessing(option) {
        if (this.ids.length <= 0) {
          this.$message({
            type: "warning",
            message: "请选择项"
          });
          return;
        }

        this.$confirm("确认继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/sideboardDevice/cellBatchProcessing",
            method: "post",
            data: {
              ids: this.ids,
              option: option,
            },
            timeout: 6000000,
          }).then(()=>{
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          })
        }).catch(() => {});
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
